import Card from "./component/Card";

function App() {
  return (
    <div className="App">
    <Card/>
    </div>
  );
}

export default App;
